<div class="survey">
  <ng-container *ngIf="!isLoadingFaqSurveyRating; else faqSurveyLoadingTemplate">
    <ng-container *ngIf="!hasFaqSurveyRatingError && !hasFaqSurveyReasonError; else faqSurveyErrorTemplate">
      <ng-container *ngIf="!hasAnsweredFaqSurveyRating; else faqSurveyAnsweredTemplate">
        <span class="survey-text margin">Essa informação foi útil?</span>

        <div class="rating-buttons-container">
          <app-button
            class="button-margin"
            [text]="'Sim'"
            [iconName]="'thumbs-up'"
            [defaultHeight]="false"
            [outline]="true"
            [shortPadding]="true"
            (clickEvent)="handleFaqSurveyRatingClick(faqSurveyAnswerOptions.POSITIVA)"
          ></app-button>

          <app-button
            [text]="'Não'"
            [iconName]="'thumbs-down'"
            [defaultHeight]="false"
            [outline]="true"
            [shortPadding]="true"
            (clickEvent)="handleFaqSurveyRatingClick(faqSurveyAnswerOptions.NEGATIVA)"
          ></app-button>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-container *ngIf="shouldDisplayFaqSurveyReason">
  <div class="survey-reason-container">
    <ng-container *ngIf="!isLoadingFaqSurveyReason; else faqSurveyLoadingTemplate">
      <ng-container *ngIf="!hasFaqSurveyReasonError; else faqSurveyErrorTemplate">
        <ng-container *ngIf="!hasAnsweredFaqSurveyReason">
          <textarea
            class="survey-reason"
            type="text"
            placeholder="Conte-nos, por que essa informação não lhe ajudou?"
            [(ngModel)]="faqSurveyReason"
          ></textarea>

          <div class="reason-button-container">
            <app-button
              [text]="'Enviar'"
              [disabled]="!trimmedFaqSurveyReason"
              (clickEvent)="handleFaqSurveyReasonClick()"
            ></app-button>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>


<ng-template #faqSurveyLoadingTemplate>
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</ng-template>


<ng-template #faqSurveyErrorTemplate>
  <app-error [error]="error"></app-error>
</ng-template>


<ng-template #faqSurveyAnsweredTemplate>
  <ng-container *ngIf="hasAnsweredFaqSurveyReason; else faqSurveyRatingAnsweredTemplate">
    <span class="survey-text">Resposta enviada com sucesso!</span>
  </ng-container>
</ng-template>


<ng-template #faqSurveyRatingAnsweredTemplate>
  <span class="survey-text">Agradecemos sua avaliação!</span>
</ng-template>
